<template>
  <div class="component-wrapper">
    <table>
      <tr>
        <th>Access Code</th>
        <th>District</th>
        <th>City</th>
        <th>State</th>
        <th> </th>
        <!-- <th> </th> -->
      </tr>
      <tr v-for="(district, index) in districts" :key="index">
        <td>{{district.districtCode}}</td>
        <td>{{district.districtName}}</td>
        <td>{{district.districtCity}}</td>
        <td>{{district.districtState}}</td>
        <!-- <td><a href="#">Manage District</a></td> -->
        <td><a @click.prevent="manageDistrict(district.id)">Manage District</a></td>
        <!-- <td><a @click.prevent="deleteDistrict(district.id)" class="warn">Delete</a></td> -->
      </tr>
    </table>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      districts: []
    }
  },
  mounted() {
    this.fetchDistricts()
  },
  methods: {
    fetchDistricts() {
      fb.districtsCollection.where('active', '==', true).orderBy('districtName').get().then((snap) => {
        snap.forEach((doc) => {
          this.districts.push({
            id: doc.id,
            districtCode: doc.data().districtCode,
            districtName: doc.data().districtName,
            districtCity: doc.data().districtCity,
            districtState: doc.data().districtState
          })
        })
      })
    },
    manageDistrict(id) {
      console.log('editing district', id)
      this.$store.commit('SET_GENERAL_MSG', null)
      this.$store.commit('SET_DISTRICT_ID', id)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageDistrict')
    },
    manageUsers(id) {
      console.log('managing users for: ', id)
      this.$store.commit('SET_GENERAL_MSG', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
      this.$store.commit('SET_DISTRICT_ID', id)
    },
    deleteDistrict(id) {
      console.log('deleting district: ', id)
      fb.districtsCollection.doc(id).update({
        active: false
      }).then(() => {
        console.log(id, 'successfully deleted')
        this.$store.commit('SET_GENERAL_MSG', 'District Successfully Deleted')
        this.districts = []
        this.fetchDistricts()
      }).catch((err) => {
        console.log('Error deleting document: ', err)
      })
    }
  }
}
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
}
th, td {
  padding: 15px;
  border-bottom: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
a {
  color: #7b8a1d;
}
a:hover {
  color: #c1d82f;
}
.warn {
  color: darkRed;
}
.warn:hover {
  color: red;
}
</style>
